import React, { Component } from 'react';
import { Provider, observer } from 'mobx-react';
import { history } from "../../history_mobx";
import myStore from "../../stores/store";
import { Router } from "react-router";
import CommentsWithStore from "./CommentsWithStore";


class CommentsOnly extends Component {
  render() {
    return (
      <Provider {...myStore.getStores()}>
        <Router history={history}>
          <CommentsWithStore {...this.props} standalone={true} />
        </Router>
      </Provider>
    );
  }
}

export default observer(CommentsOnly);
